import {
	MessageBox,
	Message
} from 'element-ui';
import axios from 'axios';
import router from '@/router';
import paramUtil from './param_util.js';
const httpURL = paramUtil.httpURL;

const httpURLWeather = 'https://tianqiapi.com/api?version=v6&appid=98417499&appsecret=MbmJSP3E';
axios.defaults.timeout = 15 * 1000; //请求超时单位秒
axios.defaults.baseURL = ''; //请求base url
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //设置post请求是的header信息
axios.defaults.withCredentials = false;

// axios.interceptors.request.use(
// 	config => {
// 		config.headers = {

// 		}
// 		return config
// 	},
// 	err => {
// 		return Promise.reject(err)
// 	}
// )
//http request 拦截器
axios.interceptors.response.use(
	response => {
		let that = this;
		if (response.data.code === 4003) {
			console.log(response.data.code, that.$cookies.get("hy_login_token"), "请重新登录");
			Message({
				message: '您没有权限操作！',
				type: 'error',
				duration: 1500
			})
			return false;
		}
		if (response.data.code == 101) {
			console.log(response.data.code, that.$cookies.get("hy_login_token"), "请重新登录");
			Message.success("请重新登录！");
			router.push({
				path: "/login"
			})
			// MessageBox.alert('请重新登录！', '提示', {
			// 	confirmButtonText: '确定',
			// 	type: 'warning',
			// 	callback: action => {
			// 		router.push({
			// 			path: "/login"
			// 		})
			// 	}
			// });
		}

		// if (response.data.code == 202) {
		// 	MessageBox.confirm('您的账号已在其他地方登录，您已被迫离线，是否立即重新登录?', '提示', {
		// 		cancelButtonText: '取消',
		// 		confirmButtonText: '重新登录',
		// 		type: 'warning'
		// 	}).then((res) => {
		// 		router.push({
		// 			path: "/login",
		// 			querry: {
		// 				redirect: router.currentRoute.fullPath
		// 			} //从哪个页面跳转
		// 		})
		// 	}).catch((err) => {
		// 		console.log(err)
		// 	});
		// }

		if (response.data.code === -1) {
			console.log(response.data.code, that.$cookies.get("hy_login_token"), "请重新登录");
			localStorage.removeItem('hy_login_token')
			router.push({
				path: "/login",
				querry: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		return response
	},
	err => {
		if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
			Message({
				message: '网络异常，连接超时...' + err.code + ' ' + err.message,
				type: 'error',
				duration: 1500
			})
		}
		return Promise.reject(err)
	}
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, headers = {}) {
	let that = this;
	if (params == null) {
		params = {};
	}

	params.Token = that.$cookies.get("hy_login_token");
	headers.Authorization = that.$cookies.get("hy_login_token");

	return new Promise((resolve, reject) => {
		axios.get(httpURL + url, {
			params: params,
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}



export function getWeather(url, params = {}, headers = {}) {
	let that = this;
	if (params == null) {
		params = {};
	}

	return new Promise((resolve, reject) => {
		axios.get(httpURLWeather, {
			params: params,
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
	let that = this;
	if (data == null) {
		data = {};
	}
	data.Token = that.$cookies.get("hy_login_token");
	axios.defaults.headers.post['Authorization'] = that.$cookies.get("hy_login_token");
	// that.$loading({
	// 	lock: true,
	// 	text: 'Loading',
	// 	spinner: 'el-icon-loading',
	// 	background: 'rgba(0, 0, 0, 0.7)'
	// });
	return new Promise((resolve, reject) => {
		axios.post(httpURL + url, data)
			.then(response => {
				// this.$loading().close();
				resolve(response.data);
			}, err => {
				// this.$loading().close();
				reject(err)
			})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function basicPost(url, data = {}) {
	let that = this;
	if (data == null) {
		data = {};
	}

	data.Token = that.$cookies.get("hy_login_token");
	axios.defaults.headers.post['Authorization'] = that.$cookies.get("hy_login_token");

	return new Promise((resolve, reject) => {
		axios.post(basicHttpURL + url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}
/**
 * 根据菜单编号，获取自定义列设置
 * MenuId
 * IsRefresh ：flase：只读取自定义设置的列，true：读取自定义设置的列，并进行补缺、刷新
 */
export function getColumnSetByMenuId(MenuId, IsRefresh = false) {
	let that = this;
	let params = {
		Token: that.$cookies.get("hy_login_token"),
		MenuId: MenuId,
		IsRefresh: IsRefresh
	}
	let headers = {
		Authorization: that.$cookies.get("hy_login_token")
	}

	return new Promise((resolve, reject) => {
		axios.get(httpURL + '/Httphandler/SystemSet/DocSet/DocumentColumnSet/GetColumnSetById.ashx', {
			params: params,
			headers: headers
		})
			.then(res => {
				if (res.data.code == 0) {
					resolve(res.data.result);
				} else {
					resolve([]);
				}
			})
			.catch(err => {
				reject([])
			})
	});
}
export function getExternalUrl(url, params = {}, headers = {}) {
	let that = this;
	if (params == null) {
		params = {};
	}
	return new Promise((resolve, reject) => {
		axios.get(url, {
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

export function postExternalUrl(url, data) {
	let that = this;
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}



// WEBPACK FOOTER //
// ./src/common/js/request.js